import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AvatarUpload from 'components/common/AvatarUpload';
//import React, { useEffect } from 'react';
import doggie from 'assets/img/team/76.webp';
import { Card, Col, Row } from 'react-bootstrap';
import {
  faFacebook,
  faLinkedin,
  faTwitter
} from '@fortawesome/free-brands-svg-icons';
import { Member } from '../../data/members';
import { formatDistanceToNow } from 'date-fns';
import membersService from 'services/member';

//create onchange handler for the avatar
const onChange = (updateMember: Member) => {
  console.log('Updated member:', updateMember);
  //send image to the blob storage

  //update the member
  membersService.updateMember(updateMember);
};

const MemberProfileCard = ({ memberData }: { memberData: Member | null }) => {
  return (
    <Card className="h-100">
      <Card.Body>
        <div className="border-bottom border-dashed border-300 pb-4">
          <Row className="align-items-center g-3 g-sm-5 text-center text-sm-start">
            <Col xs={12} sm="auto">
              <AvatarUpload
                size="5xl"
                src={memberData?.avatar || doggie}
                member={memberData}
                onChange={onChange}
              />
            </Col>
            <Col xs={12} sm="auto" className="flex-1">
              <h3>
                {memberData?.lastName}, {memberData?.firstName}
              </h3>
              <p className="text-800">
                Account: {memberData?.reportsToId || 'Individual'}
              </p>
              <p className="text-800">
                Joined{' '}
                {formatDistanceToNow(memberData?.dateCreated || '', {
                  addSuffix: true
                })}
              </p>
              <div>
                <a href={memberData?.linkedIn || ''} className="me-2">
                  <FontAwesomeIcon
                    icon={faLinkedin}
                    className="text-400 hover-primary"
                  />
                </a>
                <a href={memberData?.facebook || ''} className="me-2">
                  <FontAwesomeIcon
                    icon={faFacebook}
                    className="text-400 hover-primary"
                  />
                </a>
                <a href={memberData?.twitter || ''}>
                  <FontAwesomeIcon
                    icon={faTwitter}
                    className="text-400 hover-primary"
                  />
                </a>
              </div>
            </Col>
          </Row>
        </div>
        <div className="d-flex flex-between-center pt-4">
          <div>
            <h6 className="mb-2 text-800">Subscription</h6>
            <h4 className="fs-7 text-1000 mb-0">{memberData?.subscriptions}</h4>
          </div>
          <div className="text-end">
            <h6 className="mb-2 text-800">Last Edit</h6>
            <h4 className="fs-7 text-1000 mb-0">
              {formatDistanceToNow(memberData?.dateModified || '', {
                addSuffix: true
              })}
            </h4>
          </div>
          <div className="text-end">
            <h6 className="mb-2 text-800">Total Projects</h6>
            <h4 className="fs-7 text-1000 mb-0">19</h4>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default MemberProfileCard;
